import { useSession } from '@/api/hooks';
import type { User, Tenant, TeamRole } from '@/api/types';

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  tenant: Tenant | null;
  role: TeamRole | null;
  isOwner: boolean;
  isAdmin: boolean;
  canManageTeam: boolean;
  canEdit: boolean;
}

/**
 * Primary auth helper hook.
 * Reads from the session query — no network call if the query is already cached.
 */
export function useAuth(): AuthState {
  const { data: session, isLoading } = useSession();

  const user = session?.user ?? null;
  const tenant = session?.tenant ?? null;
  const role = user?.role ?? null;

  const isOwner = role === 'owner';
  const isAdmin = role === 'owner' || role === 'admin';
  const canManageTeam = isAdmin;
  const canEdit = role === 'owner' || role === 'admin' || role === 'analyst';

  return {
    isAuthenticated: !!user,
    isLoading,
    user,
    tenant,
    role,
    isOwner,
    isAdmin,
    canManageTeam,
    canEdit,
  };
}
